import { ca } from '@cian/analytics';

export function trackPopupClose(region: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Close',
    action: 'GeoSuggest',
    label: `Select/region_${region}`,
  });
}

export function trackLocationAgree(region: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Agree',
    action: 'GeoSuggest',
    label: `Select/region_${region}`,
  });
}
